/*
 * @Author: xinxin 18617269361@163.com
 * @Date: 2025-05-06 09:55:54
 * @LastEditors: xinxin 18617269361@163.com
 * @LastEditTime: 2025-12-31 15:35:29
 * @FilePath: \u-h5\src\request\request.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import router from "@/router";

// 全局安装axios并引用
import axios from "axios";
import Vue from "vue";
import { Toast } from "vant";
Vue.use(Toast);

// 创建axios实例
const instance = axios.create({
  baseURL: "https://lhback.uyou.com/", // API基础路径 lhback.uyou.com
  // baseURL: "http://192.168.0.40:8092", // API基础路径
  timeout: 10000, // 请求超时时间
});
// 请求拦截器
instance.interceptors.request.use(
  (config) => {
    // 在发送请求之前做些什么
    // 从localStorage或sessionStorage中获取token
    const token = localStorage.getItem("token");
    if (token) {
      // 如果token存在，则添加到请求头中
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    // 处理请求错误
    if (error.response && error.response.status === 401) {
      // 处理401错误，例如跳转到登录页面
      // router.replace({
      //   path: "/login",
      // });
    }
    return Promise.reject(error);
  }
);

// 响应拦截器
instance.interceptors.response.use(
  (response) => {
    // 对响应数据做点什么
    if (response && response.data.code == 401) {
      localStorage.removeItem("token");
      // router.push("/login");
    }
    return response.data;
  },
  (error) => {
    if (error.message.includes("timeout")) {
      return Toast.fail("请求超时，请稍后再试");
      return Promise.reject(error); // reject这个错误信息
    }
    console.log("请求错误", error);

    return Toast.fail("系统异常请稍后再试");

    // 处理响应错误
    return Promise.reject(error);
  }
);

export default instance;
